module.exports = __webpack_public_path__ + "static/media/overflow-hidden.01dee006.gif";